export const FEATURE_FLAGS = {
  influencers: {
    enabled: true,
    environments: ["staging"],
  },
  categoryCache: {
    enabled: false,
    environments: [],
  },
  disableLangSwitch: {
    enabled: false,
    environments: ["ruksa"],
  },
  webEngage: {
    enabled: true,
    environments: ["staging"],
  },
  gtm: {
    enabled: true,
    environments: ["staging", "production"],
  },
};
